import { mb } from './theme/mbTokens';

/** One colour per payment-line origin, shared by the order drawer and the agenda card. */
export const PAYMENT_LINE_CARD_COLOR = mb.green;
export const PAYMENT_LINE_CASH_COLOR = mb.clay;
